import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getCurrent, getCurrentFiles, getCurrentChapterFiles } from '../../actions/announcement';
import styles from './styles.module.scss';
import Loader from 'react-loader';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

const Current = ({ data, loading, getCurrent, getCurrentFiles, getCurrentChapterFiles, match }) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [announcementImage, setAnnouncementImage] = useState(null);
  const [chapterImages, setChapterImages] = useState({});
  const [imageLoading, setImageLoading] = useState(false);
  const [popupImage, setPopupImage] = useState(null);
  const [isZoomed, setIsZoomed] = useState(false);

  useEffect(() => {
    getCurrent(match.params.id);
  }, [match.params.id]);

  useEffect(() => {
    if (match.params.id) {
      getCurrentFiles(match.params.id).then((file) => {
        setAnnouncementImage(file);
      });
    }
  }, [match.params.id]);

  useEffect(() => {
    setTabIndex(0);
    setChapterImages({});
  }, [data]);

  useEffect(() => {
    if (data?.chapters && data.chapters.length > 0) {
      const chapter = data.chapters[tabIndex];
      if (chapter && !chapterImages[chapter.id]) {
        setImageLoading(true);
        getCurrentChapterFiles(match.params.id, chapter.id).then((file) => {
          setChapterImages((prev) => ({ ...prev, [chapter.id]: file }));
          setImageLoading(false);
        });
      }
    }
  }, [tabIndex, data]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        setPopupImage(null);
      }
    };

    if (popupImage) {
      document.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [popupImage]);

  const openImagePopup = (imageSrc) => {
    setPopupImage(imageSrc);
  };

  const closeImagePopup = () => {
    setPopupImage(null);
    setIsZoomed(false);
  };

  const toggleZoom = (e) => {
    e.stopPropagation();
    setIsZoomed(!isZoomed);
  };

  if (loading || !data) {
    return (
      <div className={styles.loaderWrapper}>
        <Loader />
      </div>
    );
  }

  return (
    <div className={styles.currentWrap}>
      <h1>Объявление</h1>
      <h2>{data.text}</h2>

      {announcementImage && (
        <div className={styles.announcementImage}>
          <img
            src={announcementImage}
            alt="Изображение объявления"
            className={styles.image}
            onClick={() => openImagePopup(announcementImage)}
          />
        </div>
      )}

      {data.chapters && data.chapters.length > 0 && (
        <Tabs className={styles.tabs} selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
          <TabList>
            {data.chapters.map((chapter) => (
              <Tab key={chapter.id}>{chapter.header}</Tab>
            ))}
          </TabList>

          {data.chapters.map((chapter) => (
            <TabPanel key={chapter.id}>
              <div>{chapter.content}</div>
              {imageLoading && tabIndex === data.chapters.indexOf(chapter) ? (
                <div className={styles.imageLoader}>
                  <Loader />
                </div>
              ) : chapterImages[chapter.id] && (
                <div className={styles.chapterImage}>
                  <img
                    src={chapterImages[chapter.id]}
                    alt={`Изображение ${chapter.header}`}
                    onClick={() => openImagePopup(chapterImages[chapter.id])}
                  />
                </div>
              )}
            </TabPanel>
          ))}
        </Tabs>
      )}

      {popupImage && (
        <div
          className={`${styles.imagePopupOverlay} ${isZoomed ? styles.zoomed : ''}`}
          onClick={closeImagePopup}
        >
          <img
            src={popupImage}
            alt="Просмотр изображения"
            className={`${styles.imagePopup} ${isZoomed ? styles.zoomedImage : ''}`}
            onClick={toggleZoom}
          />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.announcement.current,
  loading: state.announcement.loading,
});

export default connect(mapStateToProps, { getCurrent, getCurrentFiles, getCurrentChapterFiles })(Current);
